export default __webpack_public_path__ + "static/media/mood-24px-grey.46e4e6e7.svg";